import { observer } from 'mobx-react';
import { LoanDetailsInfoItem } from '../loanDetailsCustomCard';

const formatPoints = value => {
  return Number((Number(value) || 0).toFixed(4));
};

export const getExitPoints = (loanDetails: any) => {
  const total = Number(loanDetails?.pointsOut ?? 0);
  const capitalProvider = Number(loanDetails?.rocPointsOut ?? 0);
  const lender = Math.max(total - capitalProvider, 0);
  return { lender, capitalProvider, total };
};

export const hasExitPoints = (loanDetails: any) =>
  getExitPoints(loanDetails).total > 0;

export const ExitPointsInfoItem = observer(
  ({ loanDetails, labelStyle }: { loanDetails: any; labelStyle?: any }) => {
    const { lender, capitalProvider, total } = getExitPoints(loanDetails);
    return (
      <LoanDetailsInfoItem
        value={`${formatPoints(total)} exit points`}
        labelStyle={labelStyle}
        label={
          <>
            {formatPoints(lender)} Lender <br />
            {formatPoints(capitalProvider)} Capital Provider
          </>
        }
      />
    );
  }
);
